import type { TicketTypesConfigResponse, UpdateTicketTypesConfigRequest } from '@jq4race/shared';

import { request } from './client.js';

export async function getLocationTicketTypesConfig(
  locationId: string,
): Promise<TicketTypesConfigResponse> {
  return request<TicketTypesConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/ticket-types-config`,
    { method: 'GET' },
  );
}

export async function updateLocationTicketTypesConfig(
  locationId: string,
  input: UpdateTicketTypesConfigRequest,
): Promise<TicketTypesConfigResponse> {
  return request<TicketTypesConfigResponse>(
    `/admin/locations/${encodeURIComponent(locationId)}/ticket-types-config`,
    { method: 'PUT', body: input },
  );
}
